(() => {
  globalThis.dataLayer = globalThis.dataLayer || [];

  const pushToGtm = ({ detail }) => {
    if (!detail) return;

    globalThis.dataLayer.push({
      event: `pcp_${detail.event}`,
      pcp_event: detail.event,
      pcp_event_id: detail.event_id,
      pcp_page_type: detail.page_type,
      ...(detail.product_handle ? { pcp_product_handle: detail.product_handle } : {}),
    });
  };

  document.addEventListener('pcp:funnel-event', pushToGtm);
})();
